import { AHStatusCircle as AHStatusCircleW } from "./AHStatusCircleWeb";
import { AHStatusCircle as AHStatusCircleM } from "./AHStatusCircleMobile";
import { Platform } from "react-native";

export const AHStatusCircle =
  Platform.OS === "web" ? AHStatusCircleW : AHStatusCircleM;
